import { useEffect, useState } from "react";
import { useAuth } from "../components/AuthContext.jsx";
import {} from "lucide-react";
import ExploreAddOns from "./ExploreAddOns.jsx";
import Growth from "./Growth.jsx";
import FrequentlyAndAsk from "../components/FrequentlyAndAsk.jsx";
import QuoteAndFeature from "../components/QuoteAndFeature.jsx";
import PriceCalculatorUI from "../components/PriceCalculatorUI.jsx";
import { useTranslation } from "react-i18next";
import Packages from "../components/Packages.jsx";

const Price = () => {
  const { t } = useTranslation();
  const auth = useAuth();

  useEffect(() => {
    if (!auth.token || !auth.user || !auth.merchant) {
      localStorage.removeItem("authToken", "merchantUser", "user");
    }
  }, [auth.token, auth.user, auth.merchant]);

  const [showCalculator, setShowCalculator] = useState(false);

  useEffect(() => {
    const handleClickOutside = (e) => {
      const calculator = document.getElementById("price-calculator-popup");
      const button = document.getElementById("calculator-button");

      if (
        calculator &&
        button &&
        !calculator.contains(e.target) &&
        !button.contains(e.target)
      ) {
        setShowCalculator(false);
      }
    };

    const handleEscape = (e) => {
      if (e.key === "Escape") {
        setShowCalculator(false);
      }
    };

    if (showCalculator) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [showCalculator]);

  return (
    <div className="font-sans text-gray-900 bg-white relative">
      {/* Hero Section */}
      <section
        id="hero"
        className="relative h-screen align-middle justify-between bg-orange-3 w-full overflow-hidden text-white py-3 px-4 text-center"
      >
        <div className="absolute top-0 left-0 w-full h-[90%] z-0">
          <img
            src="/images/2d55428527690d13f9ec7e5832b09ef8feabdddb.jpg"
            alt={t("merchantApplication")}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>

        <div className="relative z-10 max-w-6xl mx-auto">
          <p className="text-xl mb-3">{t("pricing")}</p>
          <h1 className="text-4xl md:text-5xl font-bold animate-fade-in">
            {t("flexiblePricingOptions")}
          </h1>
        </div>

        <div className="absolute bottom-32 right-44 z-10">
          <a
            href="#features"
            className="px-10 text-blue-950 py-2 rounded-lg bg-gray-100 text-sm font-semibold"
          >
            {t("startFreeTrial")}
          </a>
        </div>
      </section>

      <Packages />

      <ExploreAddOns />
      <Growth />
      <QuoteAndFeature />
      <FrequentlyAndAsk />

      <PriceCalculatorUI />
    </div>
  );
};

export default Price;
